import { defineComponent as _defineComponent } from 'vue'
import Vue, { computed, nextTick, ref } from 'vue';
import { store } from '@/store';
import MostOrderedProductViewObject = Vertica.LouisPoulsen.Application.SalesDocuments.ViewModels.MostOrderedProductViewObject;
import LineItemReference from '@/ui/shared/LineItemReference.vue';
import { useValidator } from '@/core/app.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'MostOrderedProductsTable',
  props: {
    allowPurchase: { type: Boolean },
    searchResults: null,
    asyncDone: null
  },
  setup(__props: any) {

const props = __props as {allowPurchase: boolean, searchResults: MostOrderedProductViewObject[], asyncDone: { [key: string]: boolean }}

const showStock = computed<boolean>(() => store.getters['app/showStock']);
const hideB2BPrices = computed(() => store.getters['hideb2bprices/hideB2BPrices']);
const isQuoteBasketVisible = computed(() => store.getters['app/isQuoteBasketVisible']);


const references = ref<string[]>([]);

const listImageZoomModalToggled = ref<boolean>(false);
const selectedResultIndex = ref<number>(0);

function updateReference(input: any) {
    Vue.set(references.value, input.index, input.reference);
}

const $validator = useValidator();

function onAdded(variant, index) {
    nextTick(() => $validator.reset());
    Vue.set(references.value, index, '');
}

function toggleListImageZoomModal(idx):void {
    selectedResultIndex.value = idx;
    listImageZoomModalToggled.value = !listImageZoomModalToggled.value;
}

const listImageZoomModalImages = computed<CarouselImageViewObject[]>(() => {
    return props.searchResults[selectedResultIndex.value].images;
});

const fullScreenZoomImages = computed<any[]>(() => {
    return listImageZoomModalImages.value.map(img => ({ imageUrl: img.url }));
});

return { __sfc: true,showStock, hideB2BPrices, isQuoteBasketVisible, props, references, listImageZoomModalToggled, selectedResultIndex, updateReference, $validator, onAdded, toggleListImageZoomModal, listImageZoomModalImages, fullScreenZoomImages, LineItemReference }
}

})